var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState, useEffect } from 'react';
import SwiperCore, { Virtual, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { HoverListWithTab } from '../../HoverListWithTabs/HoverList';
import { useSwiper } from 'swiper/react';
SwiperCore.use([Virtual, Navigation]);
import '../../../lib/styles/swiper.scss';
import { useWindowSize } from '../../../hooks/useWindowSize';
var SwiperCarousel = function (_a) {
    var cardsArray = _a.cardsArray;
    var width = useWindowSize()[0];
    var isMobile = width < 768;
    var _b = useState(0), activeMobile = _b[0], setActiveMobile = _b[1];
    var navigationPrevRef = useRef(null);
    var navigationNextRef = useRef(null);
    var _c = useState(0), listNumber = _c[0], updateListNumber = _c[1];
    var swiperRef = useRef(null);
    var _d = useState(0), translate = _d[0], updateTranslate = _d[1];
    var _e = useState(false), isArrowsRequired = _e[0], setArrowsRequired = _e[1];
    var _f = useState(0), maxIterations = _f[0], setMaxIterations = _f[1];
    var _g = useState([]), offSetsArray = _g[0], updateOffsetsArray = _g[1];
    // useEffect(() => {}, [maxIterations, offSetsArray]);
    var CarouselArrow = function (_a) {
        var _b = _a.direction, direction = _b === void 0 ? 'left' : _b, externalRef = _a.externalRef, _c = _a.isCustomClickEvent, isCustomClickEvent = _c === void 0 ? false : _c, _d = _a.customClickFunction, customClickFunction = _d === void 0 ? function (eventPayload) {
            //console.log('eventPayload', eventPayload);
        } : _d;
        var swiperHook = useSwiper();
        var isRight = direction === 'right';
        var rotateClassDirection = isRight ? "rotate-180" : "rotate-0";
        var positionText = isRight ? "Next" : "Before";
        var handleClick = function () {
            var swiper = Array.from(swiperRef.current.getElementsByClassName('swiper swiper-initialized'));
            var swiperElement = Array.from(swiper[0].getElementsByClassName('swiper-wrapper'));
            var slideElements = Array.from(swiperRef.current.getElementsByClassName('swiper-slide'));
            if (swiperHook) {
                if (isCustomClickEvent) {
                    customClickFunction(isRight);
                    return;
                }
                if (isRight) {
                    // swiperHook.slideNext();
                    if (maxIterations < slideElements.length) {
                        //console.log('right', maxIterations);
                        var myTransform = translate - slideElements[maxIterations].offsetWidth;
                        updateOffsetsArray(__spreadArray(__spreadArray([], offSetsArray), [
                            slideElements[maxIterations].offsetWidth,
                        ]));
                        swiperElement[0].setAttribute('style', "transition: transform 400ms ease 0ms; transform: translate3d(" + myTransform + "px, 0px, 0px); width:85%; ");
                        setMaxIterations(maxIterations + 1);
                        updateTranslate(myTransform);
                    }
                }
                else {
                    if (offSetsArray.length > 0) {
                        var myTransform = translate + offSetsArray.pop();
                        //console.log('left', myTransform);
                        swiperElement[0].setAttribute('style', "transition: transform 400ms ease 0ms; transform: translate3d(" + myTransform + "px, 0px, 0px); width:85%; ");
                        setMaxIterations(maxIterations - 1);
                        updateTranslate(myTransform);
                    }
                }
            }
        };
        return (_jsx("button", __assign({ ref: externalRef, tabIndex: 0, "aria-label": "Go to " + positionText + " card", className: "carousel__button-controller carousel__button--" + direction + " rounded-full border border-blue", "aria-labelledby": "cc-arrow-icon", onClick: handleClick, style: {
                margin: direction == "left" ? '0px 0px 0px 24px' : '0px 0px 0px 20px',
            } }, { children: _jsxs("svg", __assign({ className: "button-controller__icon h-10 transform   " + rotateClassDirection + " ", viewBox: "0 0 40 41", stroke: "#0074bd", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("circle", { cx: "20", cy: "20", r: "19.5", transform: "matrix(-1 0 0 1 40 0)", stroke: "#0074bd" }, void 0),
                    _jsx("path", { d: "m22.306 15.16-5.384 5.384 5.384 5.384", fill: "none" }, void 0)] }), void 0) }), void 0));
    };
    useEffect(function () {
        setTimeout(function () {
            var _a;
            var container = Array.from(swiperRef.current.getElementsByClassName('swiper swiper-initialized'));
            if (container[0] !== undefined) {
                var swiperElement = Array.from((_a = container[0]) === null || _a === void 0 ? void 0 : _a.getElementsByClassName('swiper-wrapper'));
                var slideElements = Array.from(container[0].getElementsByClassName('swiper-slide'));
                slideElements.map(function (item, index) {
                    item.setAttribute('style', 'width: fit-content;');
                });
                var totalElementsWidth_1 = 0;
                slideElements.map(function (item, index) {
                    totalElementsWidth_1 = totalElementsWidth_1 + item.offsetWidth;
                });
                if (swiperElement[0].offsetWidth < totalElementsWidth_1 - 40) {
                    setArrowsRequired(true);
                }
                var iteration = 0;
                var count = 0;
                for (var i = 0; i < slideElements.length; i++) {
                    iteration = iteration + slideElements[i].offsetWidth;
                    if (iteration <= swiperElement[0].offsetWidth) {
                        count++;
                    }
                    else {
                        break;
                    }
                }
                setMaxIterations(count);
            }
        }, 100);
    }, []);
    useEffect(function () {
        var slideElements = Array.from(swiperRef.current.getElementsByClassName('swiper-slide'));
        slideElements.map(function (item, index) {
            item.setAttribute('style', 'width: fit-content;');
        });
    });
    var selectedItem = function (index) {
        updateListNumber(index);
    };
    var renderCarouselArrow = ['left', 'right'].map(function (direction, index) { return (_jsx(CarouselArrow, { externalRef: !index ? navigationPrevRef : navigationNextRef, direction: direction }, direction)); });
    var onBeforeInitHandler = function (swiper) {
        swiper.params.navigation.prevEl = navigationPrevRef.current;
        swiper.params.navigation.nextEl = navigationNextRef.current;
    };
    return (_jsxs("section", __assign({ className: "hover-list-tabs-container" }, { children: [_jsx("div", __assign({ className: "swiper-slide-container", ref: swiperRef }, { children: _jsxs(Swiper, __assign({ modules: [Virtual, Navigation], navigation: true, 
                    // loop={true}
                    allowTouchMove: false, onBeforeInit: onBeforeInitHandler, slidesPerGroup: 1, centeredSlides: true }, { children: [cardsArray.map(function (item, i) { return (_jsx(SwiperSlide, { children: _jsx("div", __assign({ style: { width: 'max-content', color: '#343741' }, className: "hover-list-tab flex-shrink-0", onClick: function () { return selectedItem(i); } }, { children: _jsx("p", __assign({ className: "highlighted-tab " + (i == listNumber ? 'tab-selected' : ''), style: {
                                        paddingBottom: '20px',
                                        paddingTop: '10px',
                                        fontSize: '24px',
                                    } }, { children: item.listText }), void 0) }), "card-" + i) }, "card-" + i)); }),
                        _jsx("div", __assign({ style: {
                                position: 'absolute',
                                top: '-6px',
                                padding: '6px 10px',
                                right: '-89px',
                                zIndex: '10',
                                width: '224px',
                                backgroundColor: 'white',
                            } }, { children: isArrowsRequired && renderCarouselArrow }), void 0)] }), void 0) }), void 0),
            _jsx("div", __assign({ className: " w-full " }, { children: _jsx("hr", { className: "mx-[24px] md:mx-[45px] md:block ", style: {
                        borderTop: 'solid 1px #d8dcdb',
                        margin: "" + (window.innerWidth >= 1024
                            ? '0px 156px '
                            : window.innerWidth >= 768
                                ? '0px 92px'
                                : '0px 24px'),
                    } }, void 0) }), void 0),
            _jsx(HoverListWithTab, { data: cardsArray[listNumber] }, "no-animation")] }), void 0));
};
export default SwiperCarousel;
